export default (state = {}, action) => {
  switch (action.type) {
    case "GET_USERS":
      return {
        users: action.payload.users,
        //   mobile: action.payload.mobile,
        //   token: action.payload.token,
        //   userId: action.payload.userId,
        //   resStatus: action.payload.resStatus,
        //   resMessage: action.payload.resMessage,
        //   dispatchType: action.type
      };

    // case "CREATE_USER": {
    //   return {
    //     token: action.payload.token,
    //   };
    // }

    default:
      return state;
  }
};
